module.exports = __webpack_public_path__ + "static/media/rrrr.45692e66.jpg";